export default "__VITE_ASSET__CQPLyljw__"